import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon63: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        d="M12.5 0a.5.5 0 0 1 .5.5V4h2.5a.5.5 0 0 1 .492.41L16 4.5v15a.5.5 0 0 1-.5.5h-12a.5.5 0 0 1-.5-.5V16H.5a.5.5 0 0 1-.492-.41L0 15.5V.5A.5.5 0 0 1 .5 0h12ZM15 5H4v14h11V5Zm-3-4H1v14h2V4.5a.5.5 0 0 1 .41-.492L3.5 4H12V1Zm.5 12a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1h6Zm0-3a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1h6Zm0-3a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1h6Z"
      />
    </Svg>
  )
}
